(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Flex } from "../layout";
import { Icon } from "../icons";
var CustomPaginationContainer = styled(Flex).withConfig({
  displayName: "CustomPagination__CustomPaginationContainer",
  componentId: "sc-js4s6d-0"
})(["display:flex;flex:1 0 0;justify-content:flex-end;align-items:center;color:#717171;"]);
var Label = styled('span').withConfig({
  displayName: "CustomPagination__Label",
  componentId: "sc-js4s6d-1"
})(["margin-right:auto;"]);
var PageNumber = styled('div').withConfig({
  displayName: "CustomPagination__PageNumber",
  componentId: "sc-js4s6d-2"
})(["padding:0.75rem 1rem;cursor:pointer;border-radius:4px;color:#2A0062;", " ", " ", " pointer-events:", ";"], function (props) {
  return props.current && 'background: #2EE8B9;';
}, function (props) {
  return props.disabled && 'background: rgba(0, 0, 0, 0.08);';
}, function (props) {
  return props.disabled && 'color: rgba(0, 0, 0, 0.08);';
}, function (props) {
  return props.disabled ? "none" : "initial";
});
var PagesContainer = styled('div').withConfig({
  displayName: "CustomPagination__PagesContainer",
  componentId: "sc-js4s6d-3"
})(["display:flex;"]);
var ThreeDots = styled('span').withConfig({
  displayName: "CustomPagination__ThreeDots",
  componentId: "sc-js4s6d-4"
})(["text-align:center;padding:0.75rem 1rem;color:#2A0062;", ""], function (props) {
  return props.disabled && 'color: rgba(0, 0, 0, 0.08);';
});
var ArrowIcon = styled(Icon).withConfig({
  displayName: "CustomPagination__ArrowIcon",
  componentId: "sc-js4s6d-5"
})(["cursor:pointer;margin-right:", ";margin-left:", ";pointer-events:", ";color:", ";"], function (props) {
  return props.name === "back" ? "0.5rem" : "0";
}, function (props) {
  return props.name === "forward" ? "0.5rem" : "0";
}, function (props) {
  return props.disabled ? "none" : "initial";
}, function (props) {
  return props.disabled ? "rgba(0, 0, 0, 0.08)" : "2A0062";
});

var CustomPagination = function CustomPagination(props) {
  var currentPage = props.currentPage,
      totalPages = props.totalPages,
      currentPageItems = props.currentPageItems,
      totalItems = props.totalItems,
      setCurrentPage = props.setCurrentPage,
      disabled = props.disabled,
      renderShowingString = props.renderShowingString,
      rest = _objectWithoutProperties(props, ["currentPage", "totalPages", "currentPageItems", "totalItems", "setCurrentPage", "disabled", "renderShowingString"]);

  var handleChange = function handleChange(page) {
    setCurrentPage(page);
  };

  var generatePageButtons = function generatePageButtons() {
    if (currentPage <= 4) {
      return React.createElement(PagesContainer, null, Array.from(Array(5), function (e, i) {
        return React.createElement(PageNumber, {
          onClick: function onClick() {
            return handleChange(i + 1);
          },
          current: currentPage == i + 1,
          key: i + 1,
          disabled: disabled
        }, i + 1);
      }), React.createElement(ThreeDots, null, "..."), React.createElement(PageNumber, {
        onClick: function onClick() {
          return handleChange(totalPages);
        },
        current: currentPage == totalPages,
        key: totalPages,
        disabled: disabled
      }, totalPages));
    } else if (currentPage >= totalPages - 3) {
      return React.createElement(PagesContainer, null, React.createElement(PageNumber, {
        onClick: function onClick() {
          return handleChange(1);
        },
        current: currentPage == 1,
        key: 1,
        disabled: disabled
      }, 1), React.createElement(ThreeDots, null, "..."), Array.from(Array(5), function (e, i) {
        return React.createElement(PageNumber, {
          onClick: function onClick() {
            return handleChange(totalPages - 4 + i);
          },
          current: currentPage == totalPages - 4 + i,
          key: totalPages - 4 + i,
          disabled: disabled
        }, totalPages - 4 + i);
      }));
    }

    return React.createElement(PagesContainer, null, React.createElement(PageNumber, {
      onClick: function onClick() {
        return handleChange(1);
      },
      current: currentPage == 1,
      key: 1,
      disabled: disabled
    }, 1), React.createElement(ThreeDots, null, "..."), Array.from(Array(3), function (e, i) {
      return React.createElement(PageNumber, {
        onClick: function onClick() {
          return handleChange(currentPage + i - 1);
        },
        current: currentPage == currentPage + i - 1,
        key: currentPage + i - 1,
        disabled: disabled
      }, currentPage + i - 1);
    }), React.createElement(ThreeDots, null, "..."), React.createElement(PageNumber, {
      onClick: function onClick() {
        return handleChange(totalPages);
      },
      current: currentPage == totalPages,
      key: totalPages,
      disabled: disabled
    }, totalPages));
  };

  return React.createElement(CustomPaginationContainer, rest, React.createElement(Label, null, renderShowingString(currentPageItems, totalItems)), React.createElement(ArrowIcon, {
    name: "back",
    onClick: function onClick() {
      return handleChange(currentPage - 1);
    },
    disabled: currentPage <= 1 || disabled
  }), totalPages > 9 ? generatePageButtons() : Array.from(Array(totalPages), function (e, i) {
    return React.createElement(PageNumber, {
      onClick: function onClick() {
        return handleChange(i + 1);
      },
      current: currentPage == i + 1,
      key: i,
      disabled: disabled
    }, i + 1);
  }), React.createElement(ArrowIcon, {
    name: "forward",
    onClick: function onClick() {
      return handleChange(currentPage + 1);
    },
    disabled: currentPage >= totalPages || disabled
  }));
};

CustomPagination.defaultProps = {
  disabled: false,
  hideNextButton: false,
  hidePrevButton: false,
  showFirstButton: false,
  showLastButton: false
};
CustomPagination.propTypes = {
  disabled: PropTypes.bool,
  hideNextButton: PropTypes.bool,
  hidePrevButton: PropTypes.bool,
  showFirstButton: PropTypes.bool,
  showLastButton: PropTypes.bool,
  totalItems: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  currentPageItems: PropTypes.number.isRequired
};
var _default = CustomPagination;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CustomPaginationContainer, "CustomPaginationContainer", "/home/vsts/work/1/s/src/components/pagination/CustomPagination.js");
  reactHotLoader.register(Label, "Label", "/home/vsts/work/1/s/src/components/pagination/CustomPagination.js");
  reactHotLoader.register(PageNumber, "PageNumber", "/home/vsts/work/1/s/src/components/pagination/CustomPagination.js");
  reactHotLoader.register(PagesContainer, "PagesContainer", "/home/vsts/work/1/s/src/components/pagination/CustomPagination.js");
  reactHotLoader.register(ThreeDots, "ThreeDots", "/home/vsts/work/1/s/src/components/pagination/CustomPagination.js");
  reactHotLoader.register(ArrowIcon, "ArrowIcon", "/home/vsts/work/1/s/src/components/pagination/CustomPagination.js");
  reactHotLoader.register(CustomPagination, "CustomPagination", "/home/vsts/work/1/s/src/components/pagination/CustomPagination.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/pagination/CustomPagination.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();